var rich_content_viewer_default = {
  "fontElementMap": "FNPat",
  "wrapper": "_7PmPH",
  "pluginContainerMobile": "Hg2d9",
  "viewer": "S-c0-",
  "android": "G2o4w",
  "rootedTraversedContent": "JdVll",
  "atomic": "_5b3-E",
  "toolbar": "k9vUo",
  "block": "DOxtj"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
